import { createApiCall } from 'lib/base';

const FETCH_INVESTCORE_USER_GET_PORTFOLIO_FUNDS_API_ID =
  'DASHBOARD/FETCH_INVESTCORE_USER_GET_PORTFOLIO_ITEMS_API';

const apiCall = createApiCall(
  FETCH_INVESTCORE_USER_GET_PORTFOLIO_FUNDS_API_ID,
  ({ id }) => ({
    endpoint: `/api/admin/users/${id}/portfolio-funds`,
    method: 'GET',
  })
);

export default apiCall;
